import api from '../../utils/api';

export interface ChatbotSummary {
  total_messages: number;
  unique_users: number;
  answered_count: number;
  unanswered_count: number;
  success_rate: number;
}

export interface IntentDistribution {
  intent: string;
  count: number;
}

export interface ChatSession {
  user_id: string;
  session_id: string;
  question: string;
  intent: string;
  response_status: string;
  timestamp: string;
}

export interface UnansweredQuestion {
  question: string;
  intent: string;
  timestamp: string;
  count: number;
}

export const fetchChatbotSummary = async (days: number = 30): Promise<ChatbotSummary> => {
  const response = await api.get('/master-admin/chatbot/summary', { params: { days } });
  return response.data.data;
};

export const fetchChatbotIntents = async (days: number = 30): Promise<IntentDistribution[]> => {
  const response = await api.get('/master-admin/chatbot/intents', { params: { days } });
  return response.data.data;
};

export const fetchRecentChatSessions = async (limit: number = 50): Promise<ChatSession[]> => {
  const response = await api.get('/master-admin/chatbot/sessions', { params: { limit } });
  return response.data.data;
};

export const fetchUnansweredQuestions = async (days: number = 7): Promise<UnansweredQuestion[]> => {
  const response = await api.get('/master-admin/chatbot/unanswered', { params: { days } });
  return response.data.data;
};
